<template>
  <!-- Page Content -->
  <div class="whole-page-long" id="whole-page-div">
    <div class="navbar-div">
      <Navbar
        :colorTheme="colorTheme"
        :selectedNavLink="null"
        :user="user"
        analysis="DOCS"
        @eventOnUserColorTheme="onUserColorTheme"
      />
    </div>
    <div class="row f-row">
      <div
        class="col col-12 chart-title-results text-center"
        style="font-size: 1.2rem!important; vertical-align: middle!important;"
      >
        Software Documentation
      </div>
    </div>
    <MegaMenu :model="items"></MegaMenu>

    <UserMain v-if="selection === 'docs'" />
  </div>
</template>

<script>
import MegaMenu from "primevue/megamenu";
import Navbar from "@/components/Navbar.vue";
import UserMain from "@/components/documentation/UserMain";
import { colorThemeChange, colorThemeVuex } from "@/_core/_helpers/_helpers";
import { getUserDocumentationItems } from "@/_core/data/Documentation";
import { saveUserPreferences } from "@/_core/data/SaveToDB";

export default {
  name: "Documentation",
  components: {
    MegaMenu,
    Navbar,
    UserMain
  },
  data() {
    return {
      colorTheme: true,
      selection: "docs",
      items: [],
      user: {}
    };
  },
  created() {
    this.overview_preferences = this.$store.state.user_preferences.all.items.overview_choices;
    try {
      this.colorTheme = this.overview_preferences.color_theme;
      if (this.colorTheme === undefined) {
        this.colorTheme = true;
      }
      if (!this.colorTheme) {
        colorThemeChange(this.root, this.colorTheme);
        this.onUserColorTheme(this.colorTheme);
      }
    } catch (error) {
      console.log(`Error color theme ${error}`);
    }
    this.overview_preferences = this.$store.state.user_preferences.all.items.overview_choices;
    try {
      this.user = this.$store.state.user.all.items;
    } catch (error) {
      console.log(`Error user ${error}`);
    }
    this.items = getUserDocumentationItems(this);
  },
  methods: {
    onUserColorTheme(val) {
      this.colorTheme = val;
      this.overview_preferences.color_theme = val;
      colorThemeVuex(this, this.colorTheme);
      saveUserPreferences(this);
    },
    handleClick(val) {
      console.log("handleClick");
      console.log(val);
      this.selection = val;
    }
  }
};
</script>

<style scoped></style>
